import { WidgetsTrackMain } from '@/widgets/track';

export const PagesTrackMain = () => <WidgetsTrackMain />;
